module.exports = __webpack_public_path__ + "saira-light-webfont.6f94e8b88cd48204d2db.eot";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/saira-light-webfont.eot
// module id = ../../../../../src/assets/fonts/saira-light-webfont.eot
// module chunks = styles